// extracted by mini-css-extract-plugin
export default {"root":"ITgparjt1gRKbpNb28xg","placeHolderShimmer":"NzNZrgjYjQ5k8RSJYJIe"};